import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../util/useResponsive";
import Paper from "../../atoms/Paper";
import ListHeader from "../../molecules/ListHeader";
import Headline from "../../molecules/Headline";
import ProtocolCard from "../../molecules/ProtocolCard";
const ProtocolSection = ({ metricType, instructions }) => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    return (_jsxs(Box, Object.assign({ width: "full", px: {
            base: 4,
            md: 0,
        }, mb: 3 }, { children: [isSmallScreen && (_jsx(ListHeader, { title: t("measures:measureProtocol"), size: "xs", borderBottomWidth: 0, bgColor: "none", px: 0 })), _jsxs(Paper, { children: [!isSmallScreen && (_jsx(Headline, { title: t("measures:measureProtocol"), size: "xs" })), _jsx(ProtocolCard, { protocols: [{ metricType, instructions }], borderWidth: 0, px: 6 })] })] })));
};
export default ProtocolSection;
